import React from "react";
import CloudSetup from "./cloudInformation";

const AccountDetails = () => {
  return <CloudSetup />;
};

export default AccountDetails;
